import React from 'react';
import { motion } from 'framer-motion';
import { CameraIcon } from 'lucide-react';
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/3RvNMUjWKUhDoaUZDVw4Ew/i2.png',
  alt: 'Entrenamiento funcional con cuerdas',
  className: 'col-span-2 row-span-2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/o87Qf2DC2wYHTDcQUHrZ8E/ig3.png',
  alt: 'Entrenamiento de musculación con barra',
  className: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/aefBMfsTt5LmyuUfxw92L1/i1png.png',
  alt: 'Entrenamiento funcional con llanta',
  className: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ffb6zQzmLWW88ioFBwnt5e/ig4.png',
  alt: 'Entrenamiento core con balón medicinal',
  className: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nwibAhp6dSjfSxKRcciACL/ig5.png',
  alt: 'Entrenamiento con kettlebells',
  className: 'col-span-1 row-span-1'
}];
export function GymGallery() {
  return <section className="py-24 bg-gym-dark relative overflow-hidden" data-id="element-152">
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gym-green to-transparent opacity-20" data-id="element-153"></div>

      <div className="max-w-6xl mx-auto px-4" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-155">
          <div className="flex justify-center mb-6" data-id="element-156">
            <CameraIcon size={40} className="text-gym-gold" data-id="element-157" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold uppercase tracking-wide text-white mb-4" data-id="element-158">
            Así se entrena en <span className="text-gym-green" data-id="element-159">Coach Pro</span>
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-160">
            Nuestro espacio, nuestra comunidad, nuestros resultados reales.
          </p>
        </motion.div>

        {/* Desktop masonry grid */}
        <div className="hidden md:grid grid-cols-4 grid-rows-2 gap-4 h-[600px]" data-id="element-161">
          {images.map((img, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.85,
          y: 30
        }} whileInView={{
          opacity: 1,
          scale: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15,
          ease: [0.25, 0.46, 0.45, 0.94]
        }} className={`${img.className} relative rounded-2xl overflow-hidden group cursor-pointer`} data-id="element-162">
              <img src={img.src} alt={img.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-163" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-164" />
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-500" data-id="element-165">
                <p className="text-white text-sm font-medium" data-id="element-166">{img.alt}</p>
              </div>
              {/* Green accent border on hover */}
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-gym-green/50 rounded-2xl transition-colors duration-500" data-id="element-167" />
            </motion.div>)}
        </div>

        {/* Mobile horizontal scroll */}
        <div className="md:hidden flex gap-4 overflow-x-auto pb-6 snap-x snap-mandatory scrollbar-hide -mx-4 px-4" data-id="element-168">
          {images.map((img, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="snap-center shrink-0 w-[280px] h-[350px] relative rounded-2xl overflow-hidden" data-id="element-169">
              <img src={img.src} alt={img.alt} className="w-full h-full object-cover" data-id="element-170" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" data-id="element-171" />
              <div className="absolute bottom-0 left-0 right-0 p-4" data-id="element-172">
                <p className="text-white text-sm font-medium" data-id="element-173">{img.alt}</p>
              </div>
              <div className="absolute inset-0 border border-gym-charcoalLight rounded-2xl" data-id="element-174" />
            </motion.div>)}
        </div>

        {/* Swipe hint for mobile */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8
      }} className="md:hidden text-center text-gray-500 text-sm mt-4 italic" data-id="element-175">
          Desliza para ver más
        </motion.p>
      </div>
    </section>;
}